import React from 'react';
import '../styles/Footer.css';

export const Footer: React.FunctionComponent = () => {
  return (
    <div className='footer'>
    </div>
  );
};
